'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _starHelp = require('../../feis-list/star-help');

var _starHelp2 = _interopRequireDefault(_starHelp);

var _publicHeader = require('../../public-header');

var _publicHeader2 = _interopRequireDefault(_publicHeader);

var _paymentHistory = require('./payment-history');

var _paymentHistory2 = _interopRequireDefault(_paymentHistory);

var _paymentsDue = require('./payments-due');

var _paymentsDue2 = _interopRequireDefault(_paymentsDue);

var _recentResults = require('./recent-results');

var _recentResults2 = _interopRequireDefault(_recentResults);

var _myFeiseanna = require('./my-feiseanna');

var _myFeiseanna2 = _interopRequireDefault(_myFeiseanna);

var _feisDay = require('./feis-day');

var _feisDay2 = _interopRequireDefault(_feisDay);

var _teacherFeiseanna = require('./teacher-feiseanna');

var _teacherFeiseanna2 = _interopRequireDefault(_teacherFeiseanna);

var _teacherResults = require('./teacher-results');

var _teacherResults2 = _interopRequireDefault(_teacherResults);

var _teacherSchools = require('./teacher-schools');

var _teacherSchools2 = _interopRequireDefault(_teacherSchools);

var _paymentForm = require('../../payment-form');

var _paymentForm2 = _interopRequireDefault(_paymentForm);

var _eventModal = require('./event-modal');

var _eventModal2 = _interopRequireDefault(_eventModal);

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _schools = require('ifeis-isomorphic/lib/redux/actions/schools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var UserDashboardController = function () {
  function UserDashboardController($scope, $state, $ngRedux, currentUser, fNewDependentDialog) {
    var _this = this;

    _classCallCheck(this, UserDashboardController);

    this._ = { $state: $state, $ngRedux: $ngRedux, fNewDependentDialog: fNewDependentDialog };
    this.user = currentUser;

    var now = new Date().getTime();
    var priorityPeriodInMs = 1000 * 60 * 60 * 24 * 3; // 3 days

    $ngRedux.dispatch((0, _accounts.getAccount)(this.user.id));
    $ngRedux.dispatch((0, _accounts.getMyFeiseanna)(this.user.id)).then(function (res) {
      var myUpComingFeiseanna = (res.payload || res).filter(function (f) {
        return !f.feis.is_finalized && f.registered === 1 && f.feis.dt_start < now + priorityPeriodInMs && f.feis.dt_end > now;
      }).filter(function (f) {
        return !f.feis.is_finalized && f.registered === 1;
      });

      myUpComingFeiseanna.forEach(function (feiseanna) {
        _this._.$ngRedux.dispatch({ type: '/SOCKET_JOIN_ROOM', data: { room: 'FEISEANNA::' + feiseanna.feis.id, feisId: feiseanna.feis.id } });
        _this._.$ngRedux.dispatch({ type: '/SOCKET_JOIN_ROOM', data: { room: 'EVENTS::' + feiseanna.feis.id, feisId: feiseanna.feis.id } });
        _this._.$ngRedux.dispatch({ type: '/SOCKET_JOIN_ROOM', data: { room: 'SCHEDULE::' + feiseanna.feis.id, feisId: feiseanna.feis.id } });
      });
    });
    $ngRedux.dispatch((0, _accounts.getPaymentsForAccount)(this.user.id));
    $ngRedux.dispatch((0, _accounts.getBalancesForAccount)(this.user.id));

    // If user is a teacher, load their schools feiseanna
    if (this.user.is_teacher && this.user.teacher_at && this.user.teacher_at.length) {
      this.user.teacher_at.forEach(function (schoolId) {
        $ngRedux.dispatch((0, _schools.getSchool)(schoolId)); // Load schools' details
        $ngRedux.dispatch((0, _schools.getFeiseannaForSchool)(schoolId)); // Load schools' feiseanna that are eligible to be in results section of dashboard
        $ngRedux.dispatch((0, _schools.getRegisterableFeiseannaForSchool)(schoolId)); // Load schools' feiseanna that are eligible to be in registrations section of dashboard
      });
    }

    $ngRedux.connect((0, _mapStateToController2.default)(currentUser))(this);

    $scope.$on('$destroy', function () {
      _this.myUpcomingFeiseanna.forEach(function (feiseanna) {
        _this._.$ngRedux.dispatch({ type: '/SOCKET_LEAVE_ROOM', data: { room: 'FEISEANNA::' + feiseanna.feis.id, feisId: feiseanna.feis.id } });
        _this._.$ngRedux.dispatch({ type: '/SOCKET_LEAVE_ROOM', data: { room: 'EVENTS::' + feiseanna.feis.id, feisId: feiseanna.feis.id } });
        _this._.$ngRedux.dispatch({ type: '/SOCKET_LEAVE_ROOM', data: { room: 'SCHEDULE::' + feiseanna.feis.id, feisId: feiseanna.feis.id } });
      });
    });
  }

  _createClass(UserDashboardController, [{
    key: 'go',
    value: function go(state, params, $event) {
      if ($event) {
        $event.preventDefault();
        $event.stopPropagation();
      }

      this._.$state.go(state, params);
    }
  }]);

  return UserDashboardController;
}();

exports.default = angular.module('ifeis.routes.dashboard', ['ui.router', 'ngMaterial', 'ifeis.feis-star', 'ifeis.public-header', 'ifeis.dashboard-my-feiseanna', 'ifeis.dashboard-feis-day', 'ifeis.dashboard-payments-due', 'ifeis.dashboard-payment-history', 'ifeis.dashboard-recent-results', 'ifeis.dashboard-student-feiseanna', 'ifeis.dashboard-student-results', 'ifeis.dashboard-teacher-schools']).config(function ($stateProvider) {
  $stateProvider.state('dashboard', {
    url: '/dashboard',
    template: require('./tpl.html'),
    controller: 'UserDashboardController',
    controllerAs: 'dash',
    resolve: {
      currentUser: function currentUser(fSession) {
        return fSession.user();
      }
    },
    ncyBreadcrumb: {
      label: 'Dashboard'
    }
  });
}).controller('UserDashboardController', UserDashboardController);


//////////////////
// WEBPACK FOOTER
// ./routes/dashboard/index.js
// module id = 523
// module chunks = 0